import { createFileRoute } from '@tanstack/react-router'
import { DateTime } from 'luxon'
import { Boundary, PageActionPortal, UsageMonthSelector } from '~/components'
import { MonthlySummary } from '~/features/usage/components/MonthlySummary'
import { SELECTED_MONTH_FORMAT, UsageOptions } from './index'

export const Route = createFileRoute('/workspaces/$workspaceId/usage/monthly-summary')({
  component: RouteComponent,
  validateSearch: UsageOptions,
})

function RouteComponent() {
  const navigate = Route.useNavigate()

  const { selectedMonth: unparsedSelectedMonth } = Route.useSearch()
  const { workspaceId } = Route.useParams()

  const selectedMonth = DateTime.fromFormat(unparsedSelectedMonth, SELECTED_MONTH_FORMAT).toJSDate()

  return (
    <>
      <PageActionPortal>
        <UsageMonthSelector
          selectedMonth={selectedMonth}
          debouncedOnChange={(date) =>
            navigate({
              from: Route.fullPath,
              to: Route.fullPath,
              search: (prev) => ({ ...prev, selectedMonth: DateTime.fromJSDate(date).toFormat(SELECTED_MONTH_FORMAT) }),
            })
          }
          className="ml-auto"
        />
      </PageActionPortal>
      <Boundary>
        <MonthlySummary selectedMonth={selectedMonth} workspaceId={workspaceId} />
      </Boundary>
    </>
  )
}
